import { forwardRef, type Ref } from 'react'
import {
  Turnstile,
  type TurnstileInstance,
  type TurnstileProps
} from '@marsidev/react-turnstile'

import config from '@/config'

type Props = {
  id?: string
  onSuccess?: TurnstileProps['onSuccess']
  onExpire?: TurnstileProps['onExpire']
  onError?: TurnstileProps['onError']
  options?: TurnstileProps['options']
}
export const Captcha = forwardRef(
  (props: Props, ref: Ref<TurnstileInstance>) => {
    return (
      <Turnstile
        ref={ref}
        {...props}
        siteKey={config.TURNSTILE_SITE_KEY!}
        options={{
          size: 'auto',
          appearance: 'interaction-only',
          theme: 'light',
          ...props.options
        }}
      />
    )
  }
)

Captcha.displayName = 'Captcha'
